import React, { useState } from 'react';
import RadioGroupField from '../../Reusable/RadioGroupField';

const RadioGroupDemo = () => {
  const data = [
    {
      id: 1,
      value: 1,
      label: 'Admin',
    },
    {
      id: 2,
      value: 2,
      label: 'Direktor',
    },
    {
      id: 3,
      value: 3,
      label: 'Autor',
    },
  ];

  const [radioOption, setRadioOption] = useState();

  const onRadioButtonChangeHendler = (event) => {
    setRadioOption(event?.target.value);
  };

  return (
    <RadioGroupField
      name={'radioOption'}
      label={'Label'}
      data={data}
      value={radioOption}
      onChange={onRadioButtonChangeHendler}
      defaultValue
    />
  );
};

export default RadioGroupDemo;
